import React from "react";
import PopUpItem from './../../PopUp/PopUpItem';
import PopupArcode from './../../PopUp/PopUpArcode';
import PopUpOther, { SERIALNUMBER } from './../../PopUp/PopUpOther';
import PopUpSearchDoc from './../../PopUp/PopUpSearch_transfer';
import { genURL, gengetURLTEST, genpostURL, genpostURLTEST } from './../../_getjson';
import { DropdownButton, MenuItem, Row, Grid, Col, Panel } from "react-bootstrap";
import { BootstrapTable, TableHeaderColumn } from 'react-bootstrap-table';
import PopUpReport from './../../PopUp/_fromShow';
import { parseJwt } from '../../parseJWT';
import { ReDate } from './../../_source/Datefn'
import PopUpwarehouse from './../../PopUp/PopUpwarehouse';
import Checkdocgroup from './../../CustomFunction/Docgroup/Checkdocgroup'
import Chackdocno from './../../CustomFunction/Docno/GetDocno'
import ChackAp from './../../CustomFunction/Csap/GetAp'
import CheckUser from './../../CustomFunction/Csuser/GetUser'
import STKwarehouse from './../../CustomFunction/STKwarehouse/Checkname'
import axios from 'axios'
import Backdrop from './../../Components/CustomBackdrop/Barckdrop'
import Snackbar from './../../Components/Snackbar/Snackbar'
import ErrorIcon from '@mui/icons-material/ErrorOutlineRounded';
import ArrowDropDownRoundedIcon from '@mui/icons-material/ArrowDropDownRounded';
import MaterialUIPickers from "./../../Components/CustomDatepicker/MaterialUIPickers"
import Topbar from "./../../Components/Customtopbar/Topbar";
import UseAutocomplete from "../../Components/CustomInput/UseAutocomplete";
import CustomInputtext from "./../../Components/CustomInput/Inputtext"
import FullScreenDialog from '../../PopUp/FullScreendialogs/FullScreen'
import FullScreenDialogNew from "../../Components/CustomDialogs/Fullscreendialog";
import Rechecked from "./Components/Rechecked";
import CheckCodeDocGroup from "../../CustomFunction/Docgroup/CheckCodeDocGroup";
import loadFromInDB from "../../CustomFunction/formAndReport/loadfrom";
import Repostview from "../../Components/Reportview/Repostview";

const listmenu = [["-", "-"]]
const rowNum = 300;
export const setRow = (count) => {
    var data = [];
    for (var i = 0; i <= count - 1; i++) {
        data[i] = { C0: i + 1, }
    }
    return data;
}

export default class index extends React.Component {
    constructor(props) {
        super(props);
        this.Groupdata_code = React.createRef();
        this.Groupdata = React.createRef();
        this.DeliNumber = React.createRef();
        this.Remark = React.createRef();
        this.Csuser = React.createRef();
        this.Csuser_code = React.createRef();
        this.barcode = React.createRef();
        this.CustomerCode = React.createRef();
        this.PS_tel = React.createRef();
        this.PS_model = React.createRef();
        this.PS_bandname = React.createRef();
        this.MileNo2 = React.createRef();
        this.SerialNO = React.createRef();
        this.Status_Move = React.createRef();
        this.state = {
            TBLastClick: -1,
            siteCodeUser: "",
            OtPopupType: "",
            DOCGROUP_code: "",
            Groupdata_txt: "",
            openBackdrop: false,
            autoClose: 3600,
            color: "warning",
            messagealert: "",
            ModelData: [],
            psmodel: "",
            ColorData: [],
            pscolor: "",
            checkenableInput: [],
            defaultvaluewarehouse: "",
            defaultwarehouse: "",
            defaultlocetion: "",
            formPrintdata: "",
        }
        this.loadModelData()
        this.loadColorData()
    }
    async componentDidMount() {
        //เช็คเปิดปิด textbox 
        await this.setState({
            checkenableInput: JSON.parse(localStorage.getItem('checkoftxt'))
        })


        let SITECODESTR = parseJwt(localStorage.getItem('Token'));
        console.log(SITECODESTR);
        this.setState({ siteCodeUser: SITECODESTR.User.SITECODE });
        this.setState({ products: setRow(rowNum) });
        this.onAddValue("Csuser", SITECODESTR.User.CODE);
        this.MileNo2.current.value = parseFloat(0).toFixed(2)

        loadFromInDB(new URLSearchParams(location.search).get("mid")).then((val) => {
            console.log("asynchronous logging has val:", val)
            this.setState({ reportUrl: val[0].reportUrl })
            this.setState({ formPrintData: val[0].formPrintData })
        })


    }
    async loadModelData() {

        let url = "CSPDSUBGROUP4/getAll?top=500";
        await axios.get(genURL(url), { timeout: 3600 }).then(res => {
            let listData = []
            for (let index = 0; index < res.data.length; index++) {
                // const element = array[index];
                listData.push({ CODE: res.data[index].CODE, MYNAMETH: res.data[index].MYNAMETH })
            }
            this.setState({ ModelData: listData })
        })
    }
    async loadColorData() {
        let url = "CSPDSUBGROUP5/getAll?top=500";
        await axios.get(genURL(url), { timeout: 3600 }).then(res => {
            console.log("res", res)
            let listData = []
            for (let index = 0; index < res.data.length; index++) {
                // const element = array[index];
                listData.push({ CODE: res.data[index].CODE, MYNAMETH: res.data[index].MYNAMETH })
            }
            this.setState({ ColorData: listData })
        })
    }


    escapeRegExp(str) { return str.replace(/,/g, " "); }
    saveData = async () => {
        const parameter = new URLSearchParams();
        var productCODE = "", productNAME = "", qty = "", WAREHOUSE = "", WAREHOUSE1 = "", LOCATION = "", UNITCODE = "", ITEMTAXTYPE = "";

        var s1 = []
        let Data = []
        if (this.state.products.length > 0) {
            for (var i = 0; i < this.state.products.length && this.state.products[i].T_Code; i++) {
                if (this.state.products[i].T_Code) {
                    if (!this.state.products[i].T_Treasury) {
                        this.setState({ opensnackbar: true })
                        this.setState({ color: "warning" })
                        this.setState({ icon: ErrorIcon })
                        this.setState({ messagealert: "ให้กำหนดคลังในตารางสินค้าก่อน" })
                        return
                    }
                    if (!this.state.products[i].T_Location) {
                        this.setState({ opensnackbar: true })
                        this.setState({ color: "warning" })
                        this.setState({ icon: ErrorIcon })
                        this.setState({ messagealert: "ให้กำหนดตำแหน่งเก็บในตารางสินค้าก่อน" })
                        return
                    }
                    if (!Number(this.state.products[i].T_Quantity)) {
                        this.setState({ opensnackbar: true })
                        this.setState({ color: "warning" })
                        this.setState({ icon: ErrorIcon })
                        this.setState({ messagealert: "ให้กำหนดปริมาณในตารางสินค้าก่อน" })
                        return
                    }
                }
                Data[i] = {
                    Productcode: this.state.products[i].T_Code, //productCODE 0
                    Productname: this.state.products[i].T_List, //productNAME 1
                    Quantity: this.state.products[i].T_Quantity, //qty 2
                    Warehouse: this.state.products[i].T_Treasury, //WAREHOUSE3
                    Location: this.state.products[i].T_Location, //Location 4
                    Unitcode: this.state.products[i].Unitcode, //Unitcode 5
                    Itemtaxtype: this.state.products[i].itemtaxtype.toString() //ITEMTAXTYPE
                }
                s1.push(Data[i])
            }
        } else {
            this.setState({ opensnackbar: true })
            this.setState({ color: "warning" })
            this.setState({ icon: ErrorIcon })
            this.setState({ messagealert: "ให้กำหนดข้อมูลในตารางสินค้าก่อน" })
            return
        }
        if (this.CustomerCode.current.value === "") {
            parameter.append("PS_tel", "");
            parameter.append("PS_model", "");
            parameter.append("PS_bandname", "");
            parameter.append("MileNo2", "");
            parameter.append("SerialNO", "");
            parameter.append("PS_servicedate", "");
            parameter.append("MoveDate", "");
            parameter.append("Status_Move", "");
        } else {
            parameter.append("PS_tel", this.PS_tel.current.value);
            parameter.append("PS_bandname", this.state.psmodel);
            parameter.append("PS_model", this.state.pscolor);
            // parameter.append("PS_model", this.PS_bandname.current.value);
            parameter.append("MileNo2", this.MileNo2.current.value);
            parameter.append("SerialNO", this.SerialNO.current.value);
            parameter.append("PS_servicedate", this.state.PS_servicedate);
            parameter.append("MoveDate", this.state.MoveDate);
            // parameter.append("Status_Move", this.Status_Move.current.value);
        }
        /* Success */
        parameter.append("COMPNAME", "");
        parameter.append("USER", localStorage.getItem('Username'));
        parameter.append("DOCDATE", this.state.SaleDate); //วันที่ขอโอน
        parameter.append("DOCNO", this.DeliNumber.current.value); //เลขที่ใบโอน
        parameter.append("REMARK", this.Remark.current.value); //หมายเหตุ
        parameter.append("DOCGROUP", this.Groupdata_code.current.value); //กลุ่มข้อมูล
        parameter.append("PS_arcode", this.CustomerCode.current.value); //UserFile ARCODE

        parameter.append("SITECODE", ""); //UserFile ARCODE

        parameter.append("listItem", JSON.stringify(s1));
        var Uststus = true;
        for (var pair of parameter.entries()) {
            console.log(pair);
            if (pair[1] === "" && pair[0] === "DOCGROUP") {
                Uststus = false;
                this.setState({ opensnackbar: true })
                this.setState({ color: "warning" })
                this.setState({ icon: ErrorIcon })
                this.setState({ messagealert: "กรุณาเลือกกลุ่มข้อมูล" })
            } else if (pair[1] === "" && pair[0] === "ITEMS") {
                Uststus = false;
                this.setState({ opensnackbar: true })
                this.setState({ color: "warning" })
                this.setState({ icon: ErrorIcon })
                this.setState({ messagealert: "กรุณาเลือกสินค้า" })
            } else if (pair[1] !== "" && pair[0] === "ITEMS") {
                let datainitem = pair[1].split(",");
                if (datainitem[4] === "undefined" || datainitem[4] === "") {
                    Uststus = false;
                    this.setState({ opensnackbar: true })
                    this.setState({ color: "warning" })
                    this.setState({ icon: ErrorIcon })
                    this.setState({ messagealert: "กรุณาเลือกตำแหน่งเก็บของรายการสินค้า" })
                }
            }
        }
        console.log(Uststus);
        if (Uststus === true) {
            this.setState({ openBackdrop: true })
            var url = "CSSTKMOVEREQ/SAVE?user=";
            // await axios.post(genpostURLTEST("/SAVE?user="), parameter).then(res => {
            await axios.post(genpostURL("CSSTKMOVEREQ/SAVE?user="), parameter).then(res => {
                console.log(res.data);
                if (res.data.status === "success") {
                    this.setState({ opensnackbar: true })
                    this.setState({ color: "success" })
                    this.setState({ icon: ErrorIcon })
                    this.setState({ messagealert: "บันทึกสำเร็จ" })
                    setTimeout(() => {
                        this.setState({ openBackdrop: false })
                        this._print(res.data.docno)
                        this.setState({ docno: res.data.docno })
                    }, 30);
                } else {
                    this.setState({ opensnackbar: true })
                    this.setState({ color: "warning" })
                    this.setState({ icon: ErrorIcon })
                    this.setState({ messagealert: "บันทึกไม่สำเร็จ" + res.data.status })
                    this.setState({ openBackdrop: false })
                }
            }).catch(error => {
                this.setState({ opensnackbar: true })
                this.setState({ color: "warning" })
                this.setState({ icon: ErrorIcon })
                this.setState({ messagealert: "เกิดข้อผิดพลาด" + error })
                this.setState({ openBackdrop: false })
            });
        }
    }


    _print = (val) => {
        this.setState({

            openReportFullScreenDialog: true,
            titleReportFullScreenDialog: "พิมพ์ใบขอโอน"
        })

        try {
            if (formPrintdata.length > 1) {
                this.setState({ opensnackbar: true })
                this.setState({ color: "warning" })
                this.setState({ icon: ErrorIcon })
                this.setState({ messagealert: "กรุณาตรวจสอบลิงค์ From จำนวนลิงค์ฟอร์มมี " + formPrintdata.length })
                return;
            }
        } catch (error) {
            console.log("error", error);
        }
        if (this.DeliNumber.current.value !== "") {
            this._callForm(
                val
            );
        } else {
            // AlertPopup("Warning", "ไม่อยู่ในเงื่อนไขการพิมพ์");
            this.setState({ opensnackbar: true })
            this.setState({ color: "warning" })
            this.setState({ icon: ErrorIcon })
            this.setState({ messagealert: "ไม่อยู่ในเงื่อนไขการพิมพ์" })
            return;
        }
        // setTimeout(() => {
        //     localStorage.removeItem("countprint");
        //     localStorage.removeItem("creditType");
        //     localStorage.removeItem("docno");
        // }, 200);


        // this.setState({ SwitchReport: !this.state.SwitchReport });
    };

    _replacePage = (e) => {
        window.location.replace(e);
    }
    Get_PopUpOther = async (val) => {
        var data = val.split("|");
        for (var i = 0; i < data.length; i++) {
            data[i] = data[i].trim();
        }
        switch (this.state.OtPopupType) {
            case "Groupdata":
                this.Groupdata_code.current.value = data[0]
                this.Groupdata.current.value = data[1]
                this.setState({ Groupdata_txt: data[1] });
                await Chackdocno(data[0], "CSStkMoveReq").then(async (result1) => {
                    console.log(result1);
                    if (result1 !== undefined) {
                        this.DeliNumber.current.value = await result1
                    } else {
                        this.DeliNumber.current.value = ""
                    }
                }).catch((err) => {
                    this.DeliNumber.current.value = ""
                    console.log(err);
                });
                break;
            default:
                break;
        }
    };
    CalendarOnChange = (data, DateUp) => {
        var Backup = "";
        var today = new Date(data);
        if (DateUp) { today.setDate(today.getDate() + DateUp); }
        var dd = today.getDate();
        var mm = today.getMonth() + 1; //January is 0!
        var yyyy = today.getFullYear();
        if (dd < 10) { dd = '0' + dd }
        if (mm < 10) { mm = '0' + mm }
        today = dd + '/' + mm + '/' + (yyyy + 543);
        // setTimeout(() => {
        //     Backup = this.state.MenuItem;
        //     this.setState({ MenuItem: "" });
        // }, 0);
        // setTimeout(() => {
        //     this.setState({ MenuItem: Backup });
        // }, 10);
        return today;
    }
    /*---------------------------------------------vvvvvvvvvvvvvvv---center---vvvvvvvvvvvvvvv---------------------------------------------*/
    FuncTest = (e) => {
        // var data = ["26-HO-08232-2MA-X8JT1","2901-SUP-40400K23002","312-00020"];
        var data = ["11-B21300-BK-YE"];
        for (var i = 0; i < data.length; i++) {
            this.AddDataTable(data[i]);
        }
    }
    _cellButton(cell, row, enumObject, rowIndex) {
        var btn = this.state.products[rowIndex].BTN_Code;
        var btnShow = "";
        switch (btn) {
            case 1:
                btnShow = <div id={"Icon_row" + row.C0} style={{ cursor: "pointer", fontSize: "14px" }} onClick={() => this.Switch_PopUpItem("Search_Table")} onMouseDown={(e) => { this.setState({ TBLastClick: row.C0 }) }}>
                    <i className="fas fa-search" style={{ paddingTop: "7px" }}></i>
                </div>;
                break;
            case 2:
                btnShow = <div id={"Icon_row" + row.C0} style={{ cursor: "pointer" }}>
                    <i className="far fa-trash-alt" style={{ fontSize: "14px" }}></i>
                </div>;
                break;
            default: btnShow = <i id={"Icon_row" + row.C0} style={{ fontSize: "10px", color: "#000" }} ></i>; break;
        }
        return (<div>{btnShow}</div>);
    }
    rowclassFormat = (row, rowIdx) => {
        return '';
    }
    onRowClick = (row, col, id) => {

        this.setState({ cellValue: row.T_Code })
        this.setState({ WHRow: id })
        var Pr = this.state.products;
        var j = rowNum;

        // ไม่ให้คีย์ข้ามแถว
        this.setState({ col1: false });
        this.setState({ col: false });

        // จำนวนเต็มเวลาคลิก
        var T_Quantity = row.T_Quantity
        if (col === 10 && T_Quantity !== "" && T_Quantity !== undefined) {
            row.T_Quantity = parseFloat(T_Quantity).toFixed(0)
        }

        for (var i = 0; i < Pr.length; i++) {
            Pr[i].BTN_Code = 0;
            Pr[i].BTN_Treasury = 0;
            Pr[i].BTN_Location = 0;
        }

        // หาจากล่างขึ้นบน
        for (var i = this.state.products.length - 1; i >= 0; i--) {
            //หา แถวที่ว่างบนสุดใน products Table
            if (!this.state.products[i].T_Code) {
                j = i;
            }
        }

        // BTN ค้นหาได้เฉพาะในแถว
        if ((col === 1 && j === id) || (col === 1 && Pr[id].T_Code !== undefined)) {
            this.setState({ col1: true });
            Pr[id].BTN_Code = 1;
        }
        else if (col === 5 && typeof row.T_Code !== "undefined" && row.T_Code !== "") {
            this.setState({ productcodeinrow: row.T_Code })
            this.setState({ productcodeinrow1: row.T_Treasury });
            Pr[id].BTN_Treasury = 1;
        }
        else if (col === 7 && typeof row.T_Code !== "undefined" && row.T_Code !== "") {
            this.setState({ productcodeinrow: row.T_Code })
            this.setState({ productcodeinrow1: row.T_Treasury });
            Pr[id].BTN_Location = 1;
        }

        // ให้เพิ่มข้อมูลในแถวที่มีรหัสสินค้าได้
        if (typeof row.T_Code !== "undefined" && row.T_Code !== "") {
            this.setState({ col: true });
        }

        this.setState({ products: Pr });
        // if (col === 3 && row.T_Code !== null) {
        //     this.setState({
        //         se_Row: row.C0,
        //         se_PRODUCTCODE: row.T_Code,
        //         se_WAREHOUSE: row.T_Treasury,
        //         se_LOCATION: row.T_Location,
        //     });
        //     this.Switch_OtherSERIALNUMBER();
        // }
    }
    onBeforeSaveCell = (row, cellName, cellValue) => {
        if (cellName === 'T_Code' && cellValue === "") {
            setTimeout(() => { this.ReLoadData(); }, 250);
        }
    }
    onAfterSaveCell = (row, cellName, cellValue) => {
        // ทศนิยม 2 ตำแหน่ง จำนวนเงิน
        var T_Quantity = row.T_Quantity
        // console.log(cellName, T_Quantity);
        if (T_Quantity !== "") {
            row.T_Quantity = parseFloat(T_Quantity).toFixed(2)
        }
        //end

        var cellValue1 = this.state.cellValue
        if (cellName === 'T_Code' && cellValue !== "" && cellValue1 !== cellValue) {
            var col = this.state.products;
            col[row.C0 - 1] = [];
            col[row.C0 - 1].C0 = row.C0;
            col[row.C0 - 1].BTN_Code = row.BTN_Code;
            this.setState({ products: col });
            var url = "CSPRODUCT/Code?code=" + cellValue + "&user=" + localStorage.getItem("Username");
            axios.get(genURL(url), { timeout: 3600 }).then(res => {
                var code = ""
                if (res.data.length === 1) {
                    code = "0"
                } else {
                    code = "1"
                }
                this.AddDataTable(cellValue, row.C0 - 1, "0");
            }).catch(error => {
                console.log(error);
            });
        } /* else if (cellName === 'T_Location' && cellValue !== "") {
            // var col = this.state.products;
            this._setWarehouse("", cellValue, row.C0 - 1, "affsearch");
        } */ else if (cellName === 'T_Location' && cellValue === "") {
            var col = this.state.products;
            col[row.C0 - 1].C4_insert = "";
            this.setState({ products: col });
        } else if (cellName === 'T_Code' && cellValue === "") {
            var col = this.state.products;
            col[row.C0 - 1].T_Code = "";
            col[row.C0 - 1].T_List = "";
            col[row.C0 - 1].T_Treasury = "";
            col[row.C0 - 1].T_Location = "";
            col[row.C0 - 1].T_Unit = "";
            col[row.C0 - 1].T_Quantity = "";
            col[row.C0 - 1].C3_insert = "";
            col[row.C0 - 1].C4_insert = "";
            col[row.C0 - 1].Unitcode = "";
            col[row.C0 - 1].SERIALNUMBER = "";
            this.setState({ products: col });
        }
    }

    Get_PopUpItem = (code, data, stockCode) => {
        this.AddDataTable(code, this.state.TBLastClick - 1, stockCode);
    }
    addByBarCode = (e) => {
        if (e.key === "Enter") {
            this.AddDataTable(e.target.current.value);
            this.barcode.current.value = "";
        }
    }
    AddDataTable = async (ItemCode, row, stockCode) => {
        // var maxunit = ""
        // await STKwarehouse(ItemCode, this.state.defaultwarehouse).then((res) => {
        //     if (res !== "") {
        //         maxunit = res.stockqty
        //     } else {
        //         maxunit = ""
        //     }
        // }).catch(error => {
        //     console.log(error);
        //     maxunit = ""
        // });
        var j = rowNum;
        var col = this.state.products;
        var CSPRODUCT = ""
        if (stockCode === "0") {
            CSPRODUCT = "CSPRODUCT/Code?code="
        } else if (stockCode === "1") {
            CSPRODUCT = "CSPRODUCT/GETSearchproduct?STOCKTYPE=" + stockCode + "&checkCODE=true&txt="
        }
        var url = CSPRODUCT + ItemCode + "&user=" + localStorage.getItem("Username");
        //รหัสซ้ำให้มีอันเดียว//
        for (var i = 0; i < col.length; i++) {
            if (col[i].T_Code === ItemCode) {
                col[i].T_Quantity = parseFloat(Number(col[i].T_Quantity) + 1).toFixed(2);
                this.setState({ products: col });
                this.ReLoadData();
                return
            }
        }
        //----------------------//
        console.log(genURL(url));
        await axios.get(genURL(url), { timeout: 3600 }).then(ref => {
            if (row > -1) {
                j = row;
            } else if (this.state.TBLastClick && this.state.TBLastClick > -1) {
                j = this.state.TBLastClick - 1;
            } else {
                for (var i = this.state.products.length - 1; i >= 0; i--) {// หาจากล่างขึ้นบน
                    if (!this.state.products[i].T_Code) { j = i; }
                }
            }

            if (ref.data.length > 0) {
                col[j] = {
                    C0: j + 1,
                    T_Code: ref.data[0].CODE,
                    BTN_Code: col[0].BTN_Code,
                    T_List: ref.data[0].NAMETH,
                    // T_Treasury: ref.data[0].GIWAREHOUSE,
                    T_Treasury: this.state.defaultwarehouse,
                    C3_insert: this.state.defaultwarehouse,
                    // T_Location: ref.data[0].GILOCATION,
                    T_Location: this.state.defaultlocetion,
                    C4_insert: "",
                    T_Unit: ref.data[0].UNITNAME,
                    Unitcode: ref.data[0].STOCKUNIT,
                    T_Quantity: parseFloat(0).toFixed(2),
                    C7: ref.data[0].SALELASTPRICE,
                    C8: 0,
                    C9: ref.data[0].SALELASTPRICE - 0,
                    C10: "",
                    BTN_Location: col[0].BTN_Location,
                    MaxUnit: ref.data[0].STOCKQTY,
                    STOCKTYPE: ref.data[0].STOCKTYPE,
                    itemtaxtype: ref.data[0].TAXTYPE
                }

                // this._setWarehouse(this.state.siteCodeUser, "",j);
                this.setState({ products: col });
                if (ref.data.length === 1 && ref.data[0].PRODUCTSET === 1) {
                    j++;
                    var url = "CSPRODUCTSET/Code?code=" + ItemCode + "&user=" + localStorage.getItem("Username");
                    console.log(genURL(url));
                    axios.get(genURL(url), { timeout: 3600 }).then(ref2 => {
                        if (ref2.data.length > 0) {
                            for (var i = 0; i < ref2.data.length; i++) {
                                col[j] = {
                                    C0: j + 1,
                                    T_Code: ref2.data[i].PRODUCTCODE,
                                    BTN_Code: col[i].BTN_Code,
                                    T_List: ref2.data[i].PRODUCTNAME,
                                    T_Treasury: this.state.defaultwarehouse,
                                    C3_insert: this.state.defaultwarehouse,
                                    T_Location: this.state.defaultlocetion,
                                    C4_insert: "",
                                    T_Unit: ref2.data[i].UNITCODE,
                                    T_Quantity: 1,
                                    C7: ref2.data[i].AMOUNT,
                                    C8: ref2.data[i].DISCAMOUNT,
                                    C9: ref2.data[i].AMOUNT - ref2.data[i].DISCAMOUNT,
                                    C10: "",
                                    MaxUnit: ref2.data[i].STOCKQTY,
                                    STOCKTYPE: ref.data[0].STOCKTYPE,
                                    itemtaxtype: ref.data[0].TAXTYPE
                                }
                                if (i === ref2.data.length - 1) {
                                    this.setState({ products: col });
                                    // this._setWarehouse(this.state.siteCodeUser, "", j);
                                    this.ReLoadData();
                                }
                                j++;
                            }
                        }
                    }).catch(error => {
                        console.log(error);
                    });
                }
                this.ReLoadData();
            } else {
                col[j] = {
                    C0: j + 1
                }
                this.setState({ products: col });
                this.ReLoadData();
            }
            // this.setState({products:col});
        }).catch(error => {
            console.log(error);
        });
        // setTimeout(() => {
        //     document.getElementById("TableLoadItem").innerHTML = "";
        // }, 5000);
    }
    ReLoadData = (directions) => {      //เรียงข้อมูลใหม่ ลบแถวที่ ไม่มีรหัสสินค้า แล้วเลื่อนขึ้นมา คำนวนราคา
        var col = this.state.products;
        var NewCol = [];
        var j = 0;
        for (var i = 0; i < col.length; i++) {
            if (col[i].T_Code) {
                NewCol[j] = col[i];
                NewCol[j].C0 = j + 1;
                /*----------------------------------------------------คลัง-----*/
                // if (col[i].T_Treasury === "" || col[i].T_Location === "" || directions === "Y") {
                //     NewCol[j].T_Treasury = this.TreaSury.current.value;
                //     NewCol[j].T_Location = this.Storagelocation.current.value;
                // }
                /*------------------------------------------------------------*/
                if (col[i].C8 === "-") {
                    NewCol[j].C8 = (col[i].C7 * col[i].T_Quantity);
                } else if (col[i].C8 === "") {
                    NewCol[j].C8 = 0;
                }
                if (col[i].T_Quantity > col[i].MaxUnit) {
                    // if(col[i].MaxUnit<=0){
                    //     col[i].T_Quantity = 1;
                    // }else{
                    //     col[i].T_Quantity = col[i].MaxUnit
                    // this.setState({ opensnackbar: true })
                    // this.setState({ color: "warning" })
                    // this.setState({ icon: ErrorIcon })
                    // this.setState({ messagealert: col[i].T_Code+" จำกัดสินค้า "+col[i].MaxUnit+" "+col[i].T_Unit })
                    // }
                }
                // if(parseFloat(col[i].C8) < 10000){
                //     NewCol[j].C8 = (col[i].C7 * col[i].T_Quantity);
                // }
                NewCol[j].C9 = (col[i].C7 * col[i].T_Quantity) - NewCol[j].C8;
                j++;
            }
        }

        for (var i = j; i < col.length; i++) {
            NewCol[j] = { C0: j + 1 };
            j++;
        }
        this.setState({ products: NewCol });
    }

    /*----------------------------------------------------------------------------------------------------------------------------*/
    Switch_PopUpItem = (e) => {
        //  this.setState({ SwitchPopUpItem: !this.state.SwitchPopUpItem });

        this.setState({ typeFullScreenDialog: e })
        //open
        this.setState({ openFullScreenDialog: true })
        //title
        this.setState({ titleFullScreenDialog: "ค้นหาสินค้า-product" })
    }
    Switch_OtherPopup = (e) => {
        // this.setState({ OtPopupType: type })
        // this.setState({ SwitchOtherPopup: !this.state.SwitchOtherPopup });

        //ชื่อ
        this.setState({ OtPopupType: e })
        //ชื่อ
        this.setState({ typeFullScreenDialog: e })
        //open
        this.setState({ openFullScreenDialog: true })
        if (e === "Groupdata") {
            this.setState({ titleFullScreenDialog: "เลือกรายการ-csdocgroup" })
        }
        if (e === "Department") {
            this.setState({ titleFullScreenDialog: "เลือกรายการ-csdepartment" })
        }
        if (e === "Branch") {
            this.setState({ titleFullScreenDialog: "เลือกรายการ-cssite" })
        }
        if (e === "CreditCode") {
            this.setState({ titleFullScreenDialog: "เลือกรายการ-creditcode" })
        }
    }
    Switch_Report = (e) => {
        this.setState({ SwitchReport: !this.state.SwitchReport });
    }
    Switch_OtherSERIALNUMBER = (type) => {
        this.setState({ SwitchSERIALNUMBERPopup: !this.state.SwitchSERIALNUMBERPopup });
    }
    Switch_PopupArcode = (e) => {
        //ชื่อ
        this.setState({ typeFullScreenDialog: "ar" })
        //open
        this.setState({ openFullScreenDialog: true })
        this.setState({ titleFullScreenDialog: " ค้นหาลูกค้า " })
    }
    /*------------------------------------------------------------พิเศษ------------------------------------------------------------*/
    SwitchValue = () => {
        this.Groupdata.current.value = this.state.Groupdata_txt
    }
    onChangeData = (e) => {
        var Ref = this.state.LastRef;
        if (e.key === "Enter") {
            this.onAddValue(Ref, e.target.current.value)
        }
    }
    onAddValue = async (type, value, Fix) => {
        if (value) {
            switch (type) {
                case "Groupdata":
                    Checkdocgroup(value, "CSStkMoveReq").then(async (result) => {
                        if (result !== "") {
                            this.Groupdata_code.current.value = value
                            this.Groupdata.current.value = result
                            this.setState({ Groupdata_txt: result });
                            if (Fix !== "Y") {
                                await Chackdocno(value, "CSStkMoveReq").then((result1) => {
                                    if (result1 !== "") {
                                        this.DeliNumber.current.value = result1
                                    } else {
                                        this.DeliNumber.current.value = ""
                                    }
                                }).catch((err) => {
                                    this.DeliNumber.current.value = ""
                                    console.log(err);
                                });
                            }
                        } else {
                            this.setState({ opensnackbar: true })
                            this.setState({ color: "warning" })
                            this.setState({ icon: ErrorIcon })
                            this.setState({ messagealert: "ไม่พบข้อมูล" })
                            this.Groupdata_code.current.value = ""
                            this.Groupdata.current.value = ""
                            this.setState({ Groupdata_txt: "" });
                            this.DeliNumber.current.value = ""
                        }
                    }).catch((err) => {
                        this.Groupdata_code.current.value = ""
                        this.Groupdata.current.value = ""
                        this.setState({ Groupdata_txt: "" });
                        this.DeliNumber.current.value = ""
                        console.log(err);
                    });
                    break;
                case "CustomerCode":
                    await ChackAp(value).then((result) => {
                        console.log(result);
                        if (result !== "") {
                            let data = result.split("|")
                            this.CustomerCode.current.value = value
                            this.CustomerName.current.value = data[0]
                        } else {
                            this.setState({ opensnackbar: true })
                            this.setState({ color: "warning" })
                            this.setState({ icon: ErrorIcon })
                            this.setState({ messagealert: "ไม่พบข้อมูล" })
                            this.CustomerCode.current.value = ""
                            this.CustomerName.current.value = ""
                        }
                    }).catch((err) => {
                        this.CustomerCode.current.value = ""
                        this.CustomerName.current.value = ""
                        console.log(err);
                    });
                    break;
                case "Csuser":
                    await CheckUser(value).then(async (result) => {
                        if (result !== "") {
                            this.Csuser_code.current.value = await value
                            this.Csuser.current.value = await result
                        } else {
                            this.setState({ opensnackbar: true })
                            this.setState({ color: "warning" })
                            this.setState({ icon: ErrorIcon })
                            this.setState({ messagealert: "ไม่พบข้อมูล" })
                            this.Csuser_code.current.value = ""
                            this.Csuser.current.value = ""
                        }
                    }).catch((err) => {
                        this.Csuser_code.current.value = ""
                        this.Csuser.current.value = ""
                        console.log(err);
                    });
                    break;
                default: break;
            }
        }
    };
    onAddValue1 = async (type, value, Fix) => {
        if (value) {
            var url = "";
            switch (type) {
                case "Groupdata":
                    url = "CSDOCGROUP/Code?tablename=CSStkMoveReq&code=" + value + "&user=" + localStorage.getItem("Username") + "&top=30";
                    console.log(genURL(url));
                    await axios.get(genURL(url), { timeout: 3600 }).then(res => {
                        if (res.data.length > 0) {
                            this.Groupdata.current.value = res.data[0].MYNAMETH;
                            this.Groupdata_code.current.value = res.data[0].CODE;
                            this.setState({ Groupdata_txt: res.data[0].MYNAMETH });
                            var CODE = res.data[0].CODE.trim();
                            if (!Fix) {
                                var url1 = "CSMAXDOC/MAXDOC?tablename=CSStkMoveReq&code=" + (CODE);
                                console.log(genURL(url1));
                                axios.get(genURL(url1), { timeout: 3600 }).then(res => {
                                    if (res.data) {
                                        this.DeliNumber.current.value = res.data.maxdoc;
                                    }
                                })
                            }
                        } else {
                            this[type].current.value = "";
                            this[type + "_code"].current.value = "";
                            this.setState({ Groupdata_txt: "" });
                        }
                    }).catch(error => {
                        console.log(error);
                    });
                    break;
                case "Csuser":
                    url = "CSUSER/Chkuser?code=" + value + "&user=";
                    console.log(genURL(url));
                    await axios.get(genURL(url), { timeout: 3600 }).then(res => {
                        if (res.data.length === 1) {
                            this[type].current.value = res.data[0].MYNAMETH;
                            this[type + "_code"].current.value = res.data[0].CODE;
                        } else {
                            this[type].current.value = "";
                            this[type + "_code"].current.value = "";
                        }
                    }).catch(error => {
                        console.log(error);
                    });
                    break;
                default: break;
            }
        }
    }
    Get_PopUpSERIALNUMBER = (data1, data2) => {
        var dataArray = this.state.products;
        dataArray[this.state.se_Row - 1].SERIALNUMBER = data2.SERIALNUMBER;
        dataArray[this.state.se_Row - 1].T_Treasury = data2.WAREHOUSE;
        dataArray[this.state.se_Row - 1].T_Location = data2.LOCATION;
        this.setState({ products: dataArray });
    }
    Get_PopUparcode = (data1, data2) => {
        this.CustomerCode.current.value = data1;
    }

    reCheckData = async (type, val, fix) => {
        switch (type) {
            case "Groupdata":
                CheckCodeDocGroup(val, "CSSTKMOVEREQ").then((result) => {
                    this.Groupdata_code.current.value = val
                    this.Groupdata.current.value = result
                    this.setState({ Groupdata_txt: result });

                    console.log("result Groupdata", result);

                }).finally(_ => {
                    // CheckTaxrate(val, "CSSALE").then(async (result) => {
                    // this.TaxPersen.current.value = await result
                    // if (fix === false) {
                    //   this.GenerateDocno(value, "CSSALE")
                    // }
                    // })
                })
                break;
        }
    }

    _reCHK = async (RowData) => {
        var url = "CSSTKMOVEREQ/Getcodemain?code=" + RowData[0].docNo;

        this.setState({

            openFullScreenDialog: false,
            openBackdrop: true,
            docno: RowData[0].docNo
        })

        await axios.get(genURL(url), { timeout: 3600 }).then(res => {
            if (res.data !== "") {
                console.log("res.data", res.data);
                // this.setState({ defaultvaluewarehouse: "รหัสคลัง: " + res.data[0].SITECODE + "  รหัสที่เก็บ: " + res.data[0].SITECODE + "001" })
                this.CustomerCode.current.value = res.data[0].PS_arcode;
                this.setState({
                    SaleDate: ReDate(res.data[0].DOCDATE),
                    PS_servicedate: ReDate(res.data[0].PS_servicedate),
                    MoveDate: ReDate(res.data[0].MoveDate)

                })
                // this.Groupdata_code.current.value = res.data[0].DOCGROUP;
                //  this.onAddValue("Groupdata", res.data[0].DOCGROUP, "Y");
                this.reCheckData("Groupdata", res.data[0].DOCGROUP, true)
                this.onAddValue("Csuser", res.data[0].USERCODE);
                this.onAddValue("CustomerCode");
                this.DeliNumber.current.value = res.data[0].DOCNO
                if (RowData.T_Code) {
                    this.setState({ SaleDate: RowData.T_Code })
                }
                if (RowData.T_Treasury) { this.Remark.current.value = RowData.T_Treasury; }
                this.Remark.current.value = res.data[0].REMARK
                this.CustomerCode.current.value = res.data[0].PS_arcode;
                this.PS_tel.current.value = res.data[0].PS_tel;
                this.PS_model.current.value = res.data[0].PS_model;
                this.PS_bandname.current.value = res.data[0].PS_bandname;
                this.MileNo2.current.value = res.data[0].MileNo2.toFixed(2);
                this.SerialNO.current.value = res.data[0].SerialNO;
                this.Status_Move.current.value = res.data[0].Status_Move;
            }
        }).catch(error => {
            console.log(error);
        });
        var url1 = "CSSTKMOVEREQ/CODESUB?code=" + RowData[0].docNo;
        console.log(genURL(url1));
        await axios.get(genURL(url1), { timeout: 3600 }).then(res => {
            if (res.data !== "") {
                var row = this.state.products;
                for (var i = 0; i < row.length; i++) {
                    if (i < res.data.length) {
                        row[i].T_Code = res.data[i].PRODUCTCODE;
                        row[i].T_List = res.data[i].PRODUCTNAME;
                        row[i].T_Treasury = res.data[i].WAREHOUSEIN;
                        row[i].T_Location = res.data[i].LOCATIONIN;
                        row[i].T_Unit = res.data[i].UNITNAME;
                        row[i].Unitcode = res.data[i].UNITCODE;
                        row[i].T_Quantity = parseFloat(res.data[i].QUANTITY).toFixed(2);
                    } else {
                        row[i].T_Code = ""
                        row[i].T_List = ""
                        row[i].T_Treasury = ""
                        row[i].T_Location = ""
                        row[i].T_Unit = ""
                        row[i].Unitcode = ""
                        row[i].T_Quantity = ""
                    }
                    if (i === row.length - 1) {
                        this.setState({ products: row });
                    }
                }
            }
        }).catch(error => {
            console.log(error);
        });

        await this.setState({
            openBackdrop: false
        })
    }

    //---------------------new by kate  --------------------------

    Switch_PopUpwarehouse = (type) => {
        this.setState({ PopUpWHType: type })
        //ชื่อ
        this.setState({ typeFullScreenDialog: type })
        //open
        this.setState({ openFullScreenDialog: true })
        //title
        this.setState({ titleFullScreenDialog: "เลือกคลังและตำแหน่งเก็บ" })
    }

    Get_warehouse = (data) => {
        var DataValue = data.split("|");
        // for(var i = 0 ;i < DataValue.length;i++){DataValue[i] = DataValue[i].trim();}
        // if(this.state.PopUpWHType === "Y1"){
        //     // this.TreaSury.current.value = DataValue[0];
        //     // this.Storagelocation.current.value = DataValue[2];
        // }else if(this.state.PopUpWHType === "Y2"){
        //     // this.TreaSuryto.current.value = DataValue[0];
        //     // this.Storagelocationto.current.value = DataValue[2];
        // }
        // console.log(this.state.WHRow); 
        var Pr = this.state.products;
        var r = this.state.WHRow;
        switch (this.state.PopUpWHType) {
            case "setwarehousetable":
                Pr[r].T_Treasury = DataValue[0];
                Pr[r].T_Location = DataValue[2]
                Pr[r].C3_insert = DataValue[0]
                Pr[r].C4_insert = DataValue[2]
                break;
            default: break;
        }
        this.setState({ products: Pr });
    }

    _cellButton_btn_C4 = (cell, row, enumObject, rowIndex) => {
        return this._cellButtonWH(row.BTN_Location, "setwarehousetable");
    }
    _cellButton_btn_C3 = (cell, row, enumObject, rowIndex) => {
        return this._cellButtonWH(row.BTN_Treasury, "setwarehousetable");
    }
    _cellButtonWH = (btn, file) => {
        // console.log(btn);
        var btnShow = "";
        switch (btn) {
            case 1: btnShow =
                <div style={{ cursor: "pointer", fontSize: "14px" }} onClick={this.Switch_PopUpwarehouse.bind(null, file)}>
                    <i className="fas fa-search" style={{ paddingTop: "7px" }}></i>
                </div>;
                break;
            default: btnShow = <i></i>; break;
        }
        return (<div>{btnShow}</div>);
    }

    _setWarehouse = async (wherehouseCode, locationCode, j, affsearch) => {
        if (wherehouseCode !== "") {
            var url = "CSWAREHOUSE/Code?code=" + wherehouseCode;
            // let loadname = "load" + this.state.rowClick;
            console.log(genURL(url));
            await axios.get(genURL(url), { timeout: 3600 }).then(res => {
                let data = res.data;
                let col = this.state.products;
                if (data.length > 0) {
                    for (let i = 0; i < data.length; i++) {
                        try {
                            col[j].T_Treasury = data[i].MYNAMETH;
                        } catch (error) {
                            console.log(error);
                        }
                    }
                    this.setState({ products: col });
                }
            }).catch(error => {
                console.log(error);
            });
        }
        if (locationCode !== "") {
            let colforselect = this.state.products;
            let wh = "";
            if (affsearch !== "") {
                wh = "&sitecode=" + colforselect[j].C3_insert;
            }
            var urllo = "CSLOCATION/ByCode?code=" + locationCode + wh;
            console.log(genURL(urllo));
            await axios.get(genURL(urllo), { timeout: 3600 }).then(res => {
                let col = this.state.products;
                let data = res.data;
                if (data.length > 0) {
                    for (let i = 0; i < data.length; i++) {
                        console.log(data[i]);
                        try {
                            if (col[j].C3_insert === data[i].WAREHOUSE.trim()) {
                                col[j].T_Location = data[i].CODE;
                                col[j].C4_insert = data[i].CODE;
                            } else {

                            }
                        } catch (error) {
                            console.log(error);
                        }
                    }
                } else {
                    col[j].T_Location = "";
                    col[j].C4_insert = "";
                }

                this.setState({ products: col });

            }).catch(error => {
                console.log(error);
            });
        }
    }

    _chkload = (cell, row, enumObject, rowIndex) => {
        return (<div><i id={"load" + rowIndex}>{rowIndex + 1}</i></div>);
    }

    _print = (e) => {

        if (e !== "") {
            console.log("if Ec");
            this._callForm(e);
        }
        else {
            console.log("else Ec");

            return;
        }


        // this.setState({ SwitchReport: !this.state.SwitchReport });
    }
    _callForm = (val) => {
        this.setState({
            openReportFullScreenDialog: true,
            titleReportFullScreenDialog: "พิมพ์ใบขอโอน",
            urlsend: `${process.env.REACT_APP_REPORTURL}${this.state.reportUrl}&j_username=${process.env.REACT_APP_REPORTUSER}&j_password=${process.env.REACT_APP_REPORTPASSWORD}&output=${process.env.REACT_APP_REPORTTYPE}&api_key=${process.env.REACT_APP_REPORTAPIKEY}&docno=${val}`
        });
        // let url1 = "https://csrpt.pspl.co.th/jasperserver/";
        // let url2 = "&api_key=0WXZeIZXvvbBEoIotvJSC7H3vXnoPfRul9xNdF1u&j_username=rpt&j_password=042615116&output=pdf"
        // let url3 = "&docno=" + vel;
        // this.setState({ urlsend: url1 + "flow.html?_flowId=viewReportFlow&_flowId=viewReportFlow&ParentFolderUri=%2Freports%2FPSMT_report%2FPSMT_FROM&reportUnit=%2Freports%2FPSMT_report%2FPSMT_FROM%2FCSMoveReq&standAlone=true" + url2 + url3 })
        // setTimeout(() => {
        //  this.switchshowform()
        // }, 100);
    }

    switchshowform = (e) => {
        this.setState({ showform: !this.state.showform });
    }
    _checkDocgroup = async (e) => {
        if (e.key === 'Enter') {
            this.setState({ openBackdrop: true })
            var url = "CSDOCGROUP/Code?tablename=CSSTKMOVEREQ&code=" + this.Groupdata.current.value
            console.log(genURL(url));
            await axios.get(genURL(url), { timeout: 3600 }).then(res => {
                if (res.data.length > 0) {
                    this.setState({ Groupdata_txt: res.data[0].MYNAMETH });
                    this.setState({ DOCGROUP_code: res.data[0].CODE });
                    this.Groupdata.current.value = res.data[0].MYNAMETH;
                    this.Groupdata_code.current.value = res.data[0].CODE;
                    this.onClickDocNo()
                    this.setState({ openBackdrop: false })
                } else {
                    this.setState({ Groupdata_txt: "" });
                    this.setState({ DOCGROUP_code: "" });
                    this.Groupdata.current.value = "";
                    this.Groupdata_code.current.value = "";
                    this.DeliNumber.current.value = "";
                    this.setState({ openBackdrop: false })
                }
            }).catch(error => {
                console.log(error);
                this.setState({ opensnackbar: true })
                this.setState({ color: "warning" })
                this.setState({ icon: ErrorIcon })
                this.setState({ messagealert: "ไม่สามารถโหลดข้อมูลได้" })
                this.setState({ openBackdrop: false })
            });
        }
    }

    onClickDocNo = async () => {
        if (!this.state.DOCGROUP_code) {
            this.setState({ opensnackbar: true })
            this.setState({ color: "warning" })
            this.setState({ icon: ErrorIcon })
            this.setState({ messagealert: "ไม่พบข้อมูล" })
            // this.dialog.showAlert('กรุณาเลือกกลุ่มข้อมูล');   return;
        }
        if (this.state.DOCGROUP_code) {
            var url = "CSMAXDOC/MAXDOC?tablename=CSSTKMOVEREQ&code=" + this.state.DOCGROUP_code.trim();
            console.log(genURL(url));
            await axios.get(genURL(url), { timeout: 3600 }).then(res => {
                if (res.data.maxdoc.length > 0) {
                    this.DeliNumber.current.value = res.data.maxdoc;
                } else {
                    this.DeliNumber.current.value = "";
                }
            });
        } else {
            this.DeliNumber.current.value = "";
        }
    };
    onSearch = (e) => {
        var data = this.state.products;

        for (var i = 0; i < data.length; i++) {
            data[i].T_Code = "";
            data[i].T_List = "";
            data[i].T_Treasury = "";
            data[i].T_Location = "";
            data[i].T_Unit = "";
            data[i].Unitcode = "";
            data[i].T_Quantity = "";
            data[i].C7 = "";
            data[i].C8 = "";
            data[i].C9 = "";
            data[i].discount = "";
            data[i].C10 = "";
            this.setState({ products: data });
        }
    }
    SelectSetData = (data1, data2) => {
        switch (data1) {
            case "Calendar":
                this.setState({ SaleDate: data2 })
                break;
            case "Calendar1-up":
                this.setState({ PS_servicedate: data2 })
                break;
            case "Calendar2-up":
                this.setState({ MoveDate: data2 })
                break;
            default: break;
        }
    }
    onClick = (e) => {
        if (e.target.value !== "") {
            switch (e.target.name) {
                case "Groupdata":
                    this.Groupdata.current.value = this.Groupdata_code.current.value
                    break;
                default:
                    break;
            }
        }
    }
    onKeyDown = (e) => {
        if (e.key === "Enter") {
            if (e.target.name === "Groupdata") {
                this.onAddValue("Groupdata", e.target.value);
            }
            if (e.target.name === "CustomerCode") {
                this.onAddValue("CustomerCode", e.target.value);
            }
        }
    };
    onChange = (e) => {
        switch (e.target.name) {
            case 'Groupdata':
                if (e.target.value === "") {
                    this.setState({ Groupdata_txt: "" })
                    this.Groupdata_code.current.value = "";
                    this.DeliNumber.current.value = "";
                }
                break;
            case 'CustomerCode':
                if (e.target.value === "") {
                    this.CustomerCode.current.value = "";
                    // this.CustomerName.current.value = "";
                }
                break;
            default:
                break;
        }
    }
    onBlur = (e) => {
        if (e.target.name === "Groupdata") {
            this.Groupdata.current.value = this.state.Groupdata_txt;
        }
    };
    onClickTopbar = (e) => {
        console.log(e);
        switch (e) {
            case "save":
                this.saveData()
                break;
            case "new":
                this._replacePage("/PSSaveAskTransfer")
                break;
            case "print":
                this._print(this.state.docno)
                break;
            case "search":
                //  this.onSearch()
                this.setState({
                    typeFullScreenDialog: e,
                    openFullScreenDialog: true
                });
                break;
            default:
                break;
        }
    }
    setvalue = (e, type) => {
        if (type === 'model') {
            //console.log(type, "type", e);
            this.setState({ psmodel: e })
        }
        if (type === 'color') {
            // console.log(type, "type", e);
            this.setState({ pscolor: e })
        }
    }
    propsvalue = (data) => {
        console.log(data);
        if (data.source === "CSWAREHOUSEALL") {
            this.setState({ defaultwarehouse: data.warehouse })
            this.setState({ defaultlocetion: data.location })
        }
    }

    CloseDialog = (e) => {
        this.setState({ openFullScreenDialog: e })
    }
    CloseDialogsNew = async (e) => {

        await this.setState({ openReportFullScreenDialog: e })
        await this._replacePage("/PSSaveAskTransfer")
    }

    render() {
        return (
            <div className="PSApp" onClick={this.onClick} onKeyDown={this.onKeyDown} onChange={this.onChange} onBlur={this.onBlur}>
                <Backdrop open={this.state.openBackdrop} />
                <FullScreenDialogNew open={this.state.openReportFullScreenDialog} title={this.state.titleReportFullScreenDialog} CloseDialog={e => this.CloseDialogsNew(e)}>
                    <Repostview url={this.state.urlsend} />
                </FullScreenDialogNew>

                {/* {this.state.showform ? <PopUpReport close={this.switchshowform} url={this.state.urlsend} /> : null} */}
                {/* {this.state.SwitchSearchDoc ?  
                     <PopUpSearchDoc closePopup={() => { this.setState({ SwitchSearchDoc: !this.state.SwitchSearchDoc }) }}
                         Get_Popup={this.ReplaceThisPage} from="CSSTKMOVEREQ" userSite={this.state.siteCodeUser} /> : null}

                {/* {this.state.SwitchPopUpItem ? <PopUpItem closePopup={this.Switch_PopUpItem} Get_PopUpItem={this.Get_PopUpItem} from="CSSTKMOVEREQ" /> : null} */}
                {/* {this.state.SwitchOtherPopup ? <PopUpOther closePopup={this.Switch_OtherPopup} type={this.state.OtPopupType} Get_PopUpOther={this.Get_PopUpOther} from="CSStkMoveReq" userSite={this.state.siteCodeUser} /> : null} */}
                {this.state.SwitchSERIALNUMBERPopup ? <SERIALNUMBER closePopup={this.Switch_OtherSERIALNUMBER} type={this.state.OtPopupType} Get_PopUpOther={this.Get_PopUpSERIALNUMBER} PRODUCTCODE={this.state.se_PRODUCTCODE} WAREHOUSE={this.state.se_WAREHOUSE} LOCATION={this.state.se_LOCATION}
                /> : null}
                {/* {this.state.SwitchPopupArcode ? <PopupArcode closePopup={this.Switch_PopupArcode} Get_PopUparcode={this.Get_PopUparcode} /> : null} */}
                {/* {this.state.SwitchPopUpwarehouse ? <PopUpwarehouse closePopup={() => { this.setState({ SwitchPopUpwarehouse: !this.state.SwitchPopUpwarehouse }) }} type="setdefaultwarehouse" Get_PopUpOther={this.Get_warehouse} productcodeinrow={this.state.productcodeinrow} productcodeinrow1={this.state.productcodeinrow1} from="CSSTKMOVEREQ" /> : null} */}
                <FullScreenDialog open={this.state.openFullScreenDialog} title={this.state.titleFullScreenDialog} closeDialog={e => this.CloseDialog(e)}>
                    {/* {type === "MoneyExp" ? < PopUpSaveMoneyExp closePopup={e => this.CloseDialog(e)} AmountPayable={typeof this.state.AmountPayable !== "undefined" ? this.state.AmountPayable : "0.00"} date={this.state.BuyDate} Customer={this.APCode.current.value} from="CSPURCHASE" pms="R|1|1|0|1|1|1" get_PopUpSaveMoney={this.get_PopUpSaveMoney} /> : null}
                   */}
                    {this.state.typeFullScreenDialog === "search" ?
                        <Rechecked Dataselect={e => this._reCHK(e)} from="CSSTKMOVEREQ" />
                        // <PopUpSearchDoc closePopup={e => this.CloseDialog(e)} Get_Popup={this.ReplaceThisPage} from="CSPURCHASE" />
                        : null}
                    {/*  {type === "Search_APCode" ? <PopupApcode closePopup={e => this.CloseDialog(e)} Get_PopupApcode={this.Get_PopupApcode} /> : null} */}
                    {this.state.typeFullScreenDialog === "Groupdata" || this.state.typeFullScreenDialog === "Department" || this.state.typeFullScreenDialog === "Branch" || this.state.typeFullScreenDialog === "CreditCode" ? <PopUpOther closePopup={e => this.CloseDialog(e)} type={this.state.OtPopupType} Get_PopUpOther={this.Get_PopUpOther} from="CSStkMoveReq" userSite={""} /> : null}
                    {this.state.typeFullScreenDialog === "Search_Table" ? <PopUpItem closePopup={e => this.CloseDialog(e)} Get_PopUpItem={this.Get_PopUpItem} userSite={this.state.siteCodeUser} from="CSStkMoveReq" /> : null}
                    {this.state.typeFullScreenDialog === "setwarehousetable" ? <PopUpwarehouse closePopup={e => this.CloseDialog(e)}
                        type="setdefaultwarehouse"
                        Get_PopUpOther={this.Get_warehouse}
                        productcodeinrow={this.state.productcodeinrow}
                        productcodeinrow1={this.state.productcodeinrow1}
                        from="CSStkMoveReq" /> : null}
                    {/*   {type === "SelPRRef" ? <PopUpRefDocno closePopup={e => this.CloseDialog(e)} Title="SelPRRef" Get_PopUpRefDocno={this.Get_PopUpRefDocno} /> : null} */}
                    {this.state.typeFullScreenDialog === "ar" ? <PopupArcode closePopup={e => this.CloseDialog(e)} Get_PopUparcode={this.Get_PopUparcode} /> : null}
                </FullScreenDialog>

                <Topbar
                    listmenu={listmenu}
                    title="บันทึกใบขอโอนสินค้า"
                    onClick={e => this.onClickTopbar(e)}
                />
                <div className="PSAppfrom">
                    <Grid>
                        <Col xs={12} sm={12} md={12} lg={12}>
                            <Row className="show-grid">
                                <Col xs={12} sm={4} md={4} lg={4}>
                                    <Row className="show-grid">
                                        {/* <div className='form-group input-Bottom col-xs-12 col-sm-12 col-md-12 col-lg-12'>
                                            <div className="input-group col-xs-12 col-sm-12 col-lg-12 col-md-12">
                                                <span className="input-group-addon">วันที่ขอโอน </span>
                                                <input type="text" className="form-control" ref={this.SaleDate} name="SaleDate" disabled />
                                                <span className="input-group-addon icon"><SelectFix type="withdrawaldate" SelectSetData={this._SelectSetData} /></span>
                                            </div>
                                        </div> */}
                                        <MaterialUIPickers title="วันที่ขอโอน"
                                            DateValue={e => this.SelectSetData("Calendar", e)}
                                            defaultdate={this.state.SaleDate}
                                            open={this.state.checkenableInput['DOCDATE']}
                                        />
                                    </Row>
                                </Col>
                                <Col xs={12} sm={4} md={4} lg={4}>
                                    <Row className="show-grid">
                                        <div className='form-group input-Bottom col-xs-12 col-sm-12 col-md-12 col-lg-12'>
                                            <div className="input-group col-xs-12 col-sm-12 col-lg-12 col-md-12">
                                                <span className="input-group-addon">กลุ่มข้อมูล</span>
                                                <input type="text" className="form-control hidden" ref={this.Groupdata_code} />
                                                <input type="text" className="form-control" name="Groupdata" ref={this.Groupdata}
                                                />
                                                <span id="iconGroupdata" className="input-group-addon icon" onClick={this.Switch_OtherPopup.bind(null, "Groupdata")}> <i > <ArrowDropDownRoundedIcon fontSize="small" /></i></span>
                                            </div>
                                        </div>
                                    </Row>
                                </Col>
                                <Col xs={12} sm={4} md={4} lg={4}>
                                    <Row className="show-grid">
                                        <div className='form-group input-Bottom col-xs-12 col-sm-12 col-md-12 col-lg-12'>
                                            <div className="input-group col-xs-12 col-sm-12 col-lg-12 col-md-12">
                                                <span className="input-group-addon">เลขที่ใบขอโอน</span>
                                                <input type="text" className="form-control" ref={this.DeliNumber} readOnly />
                                            </div>
                                        </div>
                                    </Row>
                                </Col>
                                <Col xs={12} sm={8} md={8} lg={8}>
                                    <Row className="show-grid">
                                        <div className='form-group input-Bottom col-xs-12 col-sm-12 col-md-12 col-lg-12'>
                                            <div className="input-group col-xs-12 col-sm-12 col-lg-12 col-md-12">
                                                <span className="input-group-addon">หมายเหตุ</span>
                                                <input type="text" className="form-control" ref={this.Remark} tabIndex={2} />
                                            </div>
                                        </div>
                                    </Row>
                                </Col>
                                <Col xs={12} sm={4} md={4} lg={4}>
                                    <Row className="show-grid">
                                        <div className='form-group input-Bottom col-xs-12 col-sm-12 col-md-12 col-lg-12'>
                                            <div className="input-group col-xs-12 col-sm-12 col-lg-12 col-md-12">
                                                <span className="input-group-addon">พนักงาน</span>
                                                <input type="text" className="form-control hidden" ref={this.Csuser_code} />
                                                <input type="text" className="form-control" ref={this.Csuser} disabled />
                                            </div>
                                        </div>
                                    </Row>
                                </Col>

                            </Row>
                        </Col>
                    </Grid>
                    <Grid>
                        <Col xs={12} sm={12} md={12} lg={12}>
                            <Row className="show-grid">
                                <Col xs={12} sm={12} md={12} lg={12}>
                                    <Row className="show-grid">
                                        <CustomInputtext title="คลังเริ่มต้น" value={this.state.defaultvaluewarehouse} disabledvalue={true} of_title={false} of_btn={false}
                                            source={"CSWAREHOUSEALL"}
                                            propsvalue={this.propsvalue}
                                            fullWidth={true}
                                        />
                                    </Row>
                                </Col>
                            </Row>
                        </Col>
                    </Grid>
                </div>
                <div className="PSAppTable">
                    <div className="form-group col-md-12">
                        <div className="form-row">
                            <BootstrapTable
                                data={this.state.products}
                                trclassName='trclassName'
                                tableHeaderclassName='trclassName'
                                options={{
                                    noDataText: "...",
                                    onRowClick: this.onRowClick,
                                }}
                                cellEdit={{ //แก้ไข
                                    mode: 'click',
                                    blurToSave: true,
                                    beforeSaveCell: this.onBeforeSaveCell,
                                    afterSaveCell: this.onAfterSaveCell,
                                }}
                                height='400'>
                                <TableHeaderColumn row="0" rowSpan="2" dataField='C0' isKey width="20" dataAlign="center" dataFormat={this._chkload.bind(this)}></TableHeaderColumn>
                                <TableHeaderColumn row="0" colSpan="2" dataAlign="left" width="120" > <div align="center"> รหัสสินค้า </div> </TableHeaderColumn>
                                <TableHeaderColumn row="1" dataField='T_Code' dataAlign="left" editable={this.state.col1} width="70" > <div align="center"> </div> </TableHeaderColumn>
                                <TableHeaderColumn row="1" dataField='BTN_Code' editable={false} dataAlign="center" width="30" dataFormat={this._cellButton.bind(this)} columnClassName='columnClassNameFormat1'></TableHeaderColumn>
                                <TableHeaderColumn row="0" rowSpan="2" dataField='T_List' editable={false} dataAlign="left" width="120"  > <div align="center"> ชื่อสินค้า </div> </TableHeaderColumn>
                                <TableHeaderColumn row="0" rowSpan="2" dataField='SERIALNUMBER' editable={false} dataAlign="left" width="80" hidden > <div align="center"> SERIALNUMBER </div> </TableHeaderColumn>
                                <TableHeaderColumn row="0" colSpan="2" dataAlign="center" width="50" > คลัง </TableHeaderColumn>
                                <TableHeaderColumn row="1" dataField='T_Treasury' editable={this.state.col} dataAlign="center" width="50" >  </TableHeaderColumn>
                                <TableHeaderColumn row="1" dataField='BTN_Treasury' editable={false} dataAlign="center" width="30" dataFormat={this._cellButton_btn_C3.bind(this)} columnClassName='columnClassNameFormat1'> </TableHeaderColumn>
                                <TableHeaderColumn row="0" colSpan="2" dataAlign="left" width="50" > <div align="center"> ตำแหน่งเก็บ </div> </TableHeaderColumn>
                                <TableHeaderColumn row="1" dataField='T_Location' editable={this.state.col} dataAlign="center" width="50" >  </TableHeaderColumn>
                                <TableHeaderColumn row="1" dataField='BTN_Location' editable={false} dataAlign="center" width="30" dataFormat={this._cellButton_btn_C4.bind(this)} columnClassName='columnClassNameFormat1'> </TableHeaderColumn>
                                {/* <TableHeaderColumn row="1" dataField='BTN_Location' editable={false} width="25" columnclassName='columnclassNameFormat1' dataFormat={this._cellButtonC4.bind(this)}></TableHeaderColumn> */}
                                <TableHeaderColumn row="0" rowSpan="2" dataField='T_Unit' editable={false} dataAlign="center" width="80" > หน่วย </TableHeaderColumn>
                                <TableHeaderColumn row="0" rowSpan="2" dataField='T_Quantity' editable={this.state.col} dataAlign="center" width="80" > ปริมาณ </TableHeaderColumn>
                                <TableHeaderColumn row="0" rowSpan="2" dataField='C3_insert' editable={true} dataAlign="center" hidden > C3_insert </TableHeaderColumn>
                                <TableHeaderColumn row="0" rowSpan="2" dataField='C4_insert' editable={true} dataAlign="center" hidden > C4_insert </TableHeaderColumn>
                                <TableHeaderColumn row="0" rowSpan="2" dataField='Unitcode' editable={false} dataAlign="center" hidden> Unitcode </TableHeaderColumn>
                                <TableHeaderColumn dataField='itemtaxtype' editable={true} dataAlign="center" hidden> itemtaxtype </TableHeaderColumn>
                            </BootstrapTable>
                        </div>
                    </div>
                </div>
                {/* <div className='clearfix'> <hr></hr></div> */}
                <div className="PSAppTable">
                    <Grid>
                        <Col xs={12} sm={8} md={8} lg={8}>
                            <Row className="show-grid">
                                <Col xs={12} sm={6} md={6} lg={6}>
                                    <Row className="show-grid">

                                    </Row>
                                </Col>
                                <Col xs={12} sm={6} md={6} lg={6}>
                                    <Row className="show-grid">

                                    </Row>
                                </Col>
                                <Col xs={12} sm={12} md={12} lg={12}>
                                    <Row className="show-grid">

                                    </Row>
                                </Col>
                                <Col xs={12} sm={6} md={6} lg={6}>
                                    <Row className="show-grid">

                                    </Row>
                                </Col>
                                <Col xs={12} sm={6} md={6} lg={6}>
                                    <Row className="show-grid">

                                    </Row>
                                </Col>
                            </Row>
                        </Col>
                        <Col xs={12} sm={4} md={4} lg={4}>
                            <Row className="show-grid">
                                <Col xs={12} sm={12} md={12} lg={12}>
                                    <Row className="show-grid">

                                    </Row>
                                </Col>
                            </Row>
                        </Col>
                        <Row className="show-grid">
                            <Col xs={12} sm={12} md={12} lg={12}>
                                <Panel>
                                    <Panel.Heading>
                                        <Panel.Title componentclass="h5">ข้อมูลเพิ่มเติม ( User's Field) </Panel.Title>
                                    </Panel.Heading>
                                    <Panel.Body>
                                        <Col xs={12} sm={12} md={12} lg={12} >
                                            <Row className="show-grid">
                                                <Col xs={12} sm={12} md={12} lg={4}>
                                                    <div className="row">
                                                        <div className='form-group input-Bottom col-xs-12 col-sm-12 col-md-12 col-lg-12'>
                                                            <div className="input-group col-xs-12 col-sm-12 col-lg-12 col-md-12">
                                                                <span className="input-group-addon">รหัสลูกค้า</span>
                                                                <input type="text" className="form-control" ref={this.CustomerCode} />
                                                                <span onClick={this.Switch_PopupArcode.bind(null)} id="iconCustomerCode" className="input-group-addon icon">
                                                                    <i > <ArrowDropDownRoundedIcon fontSize="small" /></i>
                                                                </span>
                                                            </div>
                                                        </div>
                                                        <div className='form-group input-Bottom col-xs-12 col-sm-12 col-md-12 col-lg-12'>
                                                            <div className="input-group col-xs-12 col-sm-12 col-lg-12 col-md-12">
                                                                <span className="input-group-addon "> เบอร์โทรลูกค้า</span>
                                                                <input type="text" className="form-control " ref={this.PS_tel} tabIndex={4} />
                                                            </div>
                                                        </div>
                                                        <div className='form-group input-Bottom col-xs-12 col-sm-12 col-md-12 col-lg-12'>
                                                            <div className="input-group col-xs-12 col-sm-12 col-lg-12 col-md-12">
                                                                {/* <span className="input-group-addon "> สีรถ</span>
                                                                <input type="text" className="form-control " ref={this.PS_model} tabIndex={5} /> */}
                                                                <UseAutocomplete
                                                                    title="สี" id="color"
                                                                    datalist={this.state.ColorData}
                                                                    valueReturn={e => this.setvalue(e, "color")}
                                                                    activate={e => console.log(e)} />
                                                            </div>
                                                        </div>

                                                    </div>
                                                </Col>
                                                <Col xs={12} sm={12} md={12} lg={4}>
                                                    <div className="row">
                                                        <div className='form-group input-Bottom col-xs-12 col-sm-12 col-md-12 col-lg-12'>
                                                            <div className="input-group col-xs-12 col-sm-12 col-lg-12 col-md-12">
                                                                <UseAutocomplete
                                                                    title="รุ่น" id="model"
                                                                    datalist={this.state.ModelData}
                                                                    valueReturn={e => this.setvalue(e, "model")}
                                                                    activate={e => console.log(e)} />

                                                            </div>
                                                        </div>
                                                        <div className='form-group input-Bottom col-xs-12 col-sm-12 col-md-12 col-lg-12'>
                                                            <div className="input-group col-xs-12 col-sm-12 col-lg-12 col-md-12">
                                                                <span className="input-group-addon "> เลขไมล์</span>
                                                                <input type="text" className="form-control Price" ref={this.MileNo2} tabIndex={7} />
                                                            </div>
                                                        </div>
                                                        <div className='form-group input-Bottom col-xs-12 col-sm-12 col-md-12 col-lg-12'>
                                                            <div className="input-group col-xs-12 col-sm-12 col-lg-12 col-md-12">
                                                                <span className="input-group-addon "> หมายเลขตัวถัง</span>
                                                                <input type="text" className="form-control " ref={this.SerialNO} tabIndex={8} />
                                                            </div>
                                                        </div>
                                                    </div>
                                                </Col>
                                                <Col xs={12} sm={12} md={12} lg={4}>
                                                    <div className="row">
                                                        {/* <div className='form-group input-Bottom col-xs-12 col-sm-12 col-md-12 col-lg-12'>
                                                            <div className="input-group col-xs-12 col-sm-12 col-lg-12 col-md-12">
                                                                <span className="input-group-addon "> วันที่เข้ารับบริการ</span>
                                                                <input type="text" className="form-control " ref={this.PS_servicedate} name="PS_servicedate" tabIndex={9} />
                                                                <span id="iconCreditCode" className="input-group-addon icon"><SelectFix type="Calendar1-up" name="1" SelectSetData={this.SelectSetData} /></span>
                                                            </div>
                                                        </div> */}
                                                        <MaterialUIPickers title="วันที่เข้ารับบริการ"
                                                            DateValue={e => this.SelectSetData("Calendar1-up", e)}
                                                            defaultdate={this.state.PS_servicedate} />
                                                        <MaterialUIPickers title="วันที่ซื้อ"
                                                            DateValue={e => this.SelectSetData("Calendar2-up", e)}
                                                            defaultdate={this.state.MoveDate} />
                                                        {/* <div className='form-group input-Bottom col-xs-12 col-sm-12 col-md-12 col-lg-12'>
                                                            <div className="input-group col-xs-12 col-sm-12 col-lg-12 col-md-12">
                                                                <span className="input-group-addon "> วันที่ซื้อ</span>
                                                                <input type="text" className="form-control " ref={this.MoveDate} name="MoveDate" tabIndex={10} />
                                                                <span id="iconCreditCode" className="input-group-addon icon"><SelectFix type="Calendar1-up" name="2" SelectSetData={this.SelectSetData} /></span>
                                                            </div>
                                                        </div> */}
                                                        {/* <div className='form-group input-Bottom col-xs-12 col-sm-12 col-md-12 col-lg-12'>
                                                            <div className="input-group col-xs-12 col-sm-12 col-lg-12 col-md-12">
                                                                <span className="input-group-addon "> สถานะเอกสาร</span>
                                                                <input type="text" className="form-control " ref={this.Status_Move} tabIndex={11} />
                                                            </div>
                                                        </div> */}
                                                    </div>
                                                </Col>
                                            </Row>
                                        </Col>
                                    </Panel.Body>
                                </Panel>
                            </Col>
                        </Row>
                    </Grid>
                    <Snackbar place="br"
                        color={this.state.color}
                        icon={this.state.icon}
                        autoClose={this.state.autoClose}
                        message={this.state.messagealert}
                        open={this.state.opensnackbar}
                        closeNotification={() => { this.setState({ opensnackbar: false }) }}
                        close />
                </div>
            </div>
        );
    }
}

